import { render, staticRenderFns } from "./WfConsumerCorpCustomerForm.vue?vue&type=template&id=7ecc148c&"
import script from "./WfConsumerCorpCustomerForm.vue?vue&type=script&lang=js&"
export * from "./WfConsumerCorpCustomerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports